import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const FIELDS = [["full_name", "Full name"], ["email", "Email"], ["address1", "Address"], ["address2", "Apt, suite (optional)"],
  ["city", "City"], ["region", "State / Region"], ["zip", "ZIP / Postal code"], ["country", "Country code"]];
const OPTIONAL = ["address2", "region"];

export const ShippingForm = ({ price, onSubmit }) => {
  const [form, setForm] = useState({ country: "US" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onSubmit(form);
    if (!ok) setBusy(false);
  };

  return (
    <form onSubmit={submit} className="space-y-3">
      <p className="text-sm font-semibold">Shipping details</p>
      {FIELDS.map(([k, label]) => (
        <Input key={k} placeholder={label} required={!OPTIONAL.includes(k)} type={k === "email" ? "email" : "text"}
          value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="rounded-xl" data-testid={`merch-${k}-input`} />
      ))}
      <button disabled={busy} type="submit" data-testid="merch-checkout-button"
        className="w-full flex items-center justify-center gap-2 rounded-full bg-[#FF5A79] text-white sticker sticker-press py-3 font-bold disabled:opacity-70">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Checkout · ${price ? price.toFixed(2) : ""}
      </button>
      <p className="text-xs text-[#6E687A]">Printed on demand and shipped in 5-8 business days. Tax and shipping calculated at checkout.</p>
    </form>
  );
};
